import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-volunteer-group',
  templateUrl: './volunteer-group.component.html',
  styleUrls: ['./volunteer-group.component.scss']
})
export class VolunteerGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
